import { Component } from '@angular/core'
import { TranslateService } from '@ngx-translate/core'
import { SwiperOptions } from 'swiper/types'

@Component({
  selector: 'flowaccount-e-tax-invoice-intro',
  templateUrl: './e-tax-invoice-intro.component.html',
  styleUrl: './e-tax-invoice-intro.component.scss',
})
export class ETaxInvoiceIntroComponent {
  public config: SwiperOptions
  public configMobile: SwiperOptions
  public mockContent: object[]

  constructor(public translate: TranslateService) {}
  ngOnInit() {
    this.swiperConfig()
    this.swiperConfigMobile()
    this.showMockContent()
  }
  duplicatedMockContent() {
    return [...this.mockContent, ...this.mockContent]
  }
  swiperConfig() {
    this.config = {
      effect: 'coverflow',
      speed: 700,
      slidesPerView: 'auto',
      loop: true,
      observer: true,
      observeParents: true,
      mousewheel: true,
      centeredSlides: true,
      watchSlidesProgress: true,
      watchOverflow: true,
      coverflowEffect: {
        rotate: 0,
        stretch: 210,
        depth: 350,
        slideShadows: false,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      injectStyles: [
        `
      .swiper {
        padding: 40px 0;
      }
      .swiper-pagination-bullet {
        width: 10px;
        height: 10px;
        border-radius: 50%;
        background-color: #2898cb;
        opacity: 0.4;
      }
      .swiper-pagination-bullet-active {
        opacity: 1;
      }
      `,
      ],

      pagination: {
        clickable: true,
        dynamicBullets: true,
      },
    }
  }
  swiperConfigMobile() {
    this.configMobile = {
      speed: 700,
      slidesPerView: 'auto',
      observer: true,
      observeParents: true,
      mousewheel: true,
      watchSlidesProgress: true,
      watchOverflow: true,
      injectStyles: [
        `
      .swiper {
        padding: 40px 0;
      }
      .swiper-pagination-bullet {
        width: 10px;
        height: 10px;
        border-radius: 50%;
        background-color: #2898cb;
        opacity: 0.4;
      }
      .swiper-pagination-bullet-active {
        opacity: 1;
      }
      `,
      ],

      pagination: {
        clickable: true,
      },
    }
  }
  showMockContent() {
    const lang = this.translate.currentLang
    const url = 'https://flowaccountcdn.com/new_landing/image/our-integrations/e-tax-invoice-by-email/intro'
    this.mockContent = [
      {
        image: `${url}/testimonial_etax_1_${lang}.png`,
        imageWebp: `${url}/testimonial_etax_1_${lang}.webp`,
        imageMobile: `${url}/mobile/testimonial_etax_1_${lang}.png`,
        imageMobileWebp: `${url}/mobile/testimonial_etax_1_${lang}.webp`,
        link: 'https://farangangmor.com/',
      },
      {
        image: `${url}/testimonial_etax_2_${lang}.png`,
        imageWebp: `${url}/testimonial_etax_2_${lang}.webp`,
        imageMobile: `${url}/mobile/testimonial_etax_2_${lang}.png`,
        imageMobileWebp: `${url}/mobile/testimonial_etax_2_${lang}.webp`,
        link: 'https://www.instagram.com/scrub__in/',
      },
      {
        image: `${url}/testimonial_etax_3_${lang}.png`,
        imageWebp: `${url}/testimonial_etax_3_${lang}.webp`,
        imageMobile: `${url}/mobile/testimonial_etax_3_${lang}.png`,
        imageMobileWebp: `${url}/mobile/testimonial_etax_3_${lang}.webp`,
        link: 'https://anyflip.com/qnmid/ymkm/',
      },
    ]
  }
}
